import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { UserStatistics } from '../../entity';

@Component({
    selector: 'app-users-chart',
    templateUrl: './users-chart.component.html',
})

export class UsersChartComponent implements OnInit, OnChanges {
    @Input() userStatistics: Array<UserStatistics>;
    totalUsersNumberArray: Array<number> = new Array<number>();

    public barChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    public barChartLabels: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    public barChartType: string = 'bar';
    public barChartLegend: boolean = false;

    public barChartColors: Array<any> = [
        {
            backgroundColor: 'rgba(128, 109, 141, 1)',
            pointBackgroundColor: 'rgb(128, 109, 141)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        }
    ];

    public barChartData: any[] = [
        { data: [this.totalUsersNumberArray], label: 'Users' },
    ];

    constructor() { }

    ngOnInit() {
        this.userStatistics.forEach(item => {
            this.totalUsersNumberArray.push(item.TotalClientsNumber);
        });
    }

    ngOnChanges() {
        this.barChartData[0].data = this.totalUsersNumberArray;
    }
}
